<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4 d-flex justify-content-between">
				<div class="d-flex">
					<h1 class="h3 mb-0 text-gray-800">
						Tags
					</h1>
				</div>
				<div>
					<button 
						class="btn btn-primary ml-2"
						@click="create()">
						Novo
					</button>
					<button 
					    @click="$router.go(-1)" 
					    class="btn btn-secondary">
				       	Voltar
				    </button>
				</div>
			</div>
			<div class="card">
                <div class="card-header">
		        	<div class="d-flex justify-content-between overflow-auto">
			            <div class="text-muted fs-19 mr-2">
			            	<strong>Registros</strong>
			            </div>
				    </div>
		        </div>
		        <div class="card-body">
		            <tag-table 
		            	@update="update" 
		            	@destroy="destroy"
		            	:key="tagTableKey">
		            </tag-table>
		        </div>
		    </div>
		</div>
		<!-- Create -->
		<tag-create 
			:key="tagCreateKey"
			@reload="reload">
		</tag-create>
		<!-- Update -->
		<tag-update 
			:dado_id="dado_id"
			@reload="reload">
		</tag-update>
		<!-- Delete -->
		<bsh-confirm 
        	modal_id="confirm_destroy_tag" 
        	:dado_id="dado_id" 
        	title="Deseja realmente excluir esta tag?" 
        	btn="Excluir" 
        	btnStyle="btn-danger" 
        	method="delete" 
        	:rota="$url+'/api/adm/tags/destroy/'" 
        	@reload="reload">
        </bsh-confirm>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				tagTableKey: 1,
				tagCreateKey: 1,
				dado_id: 0
			}
		},
		methods: {
			create(){
				$('#create_tag').modal('show');
			},
			update(dado_id){
				this.dado_id = dado_id;
				$('#update_tag').modal('show');
			},
			destroy(dado_id){
				this.dado_id = dado_id;
				$('#confirm_destroy_tag').modal('show');
			},
			reload(){
				this.tagTableKey += 1;
				this.tagCreateKey += 1;
			},
		}
	}
</script>